import { store } from "./store";
import requests from "./requests";
import client_rest from "./index";
import csrfToken from "./csrfToken";

/**
 * Flag para indicar se o token está sendo atualizado ou não
 * @type {boolean}
 */
let isRefreshing = false;
/**
 * Lista de Promises que falharam e serão executadas novamente caso o token seja atualizado
 * @type {*[]}
 */
let failedQueue = [];
/**
 * axios client
 * @type {null}
 */
let client = null;

/**
 * Função que executa todas as requests que estavam com falha.
 * se tokem != null, resolve as requisições (executa o .then da Promise que foi criada e adicionada a fila de falhas)
 * @param error
 * @param token
 */
const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

/**
 * Função interceptor para alterar as configurações da request
 * @param config
 * @returns {*}
 */
export function request_ok(config) {
  if (!store.getters.publicRoutes.includes(config.url))
    config.headers["Authorization"] = store.getters.token;
  store.commit("openConection");
  return config;
}

/**
 * Função interceptor para manipular algum erro na request
 * @param config
 * @returns {*}
 */
export function request_error(error) {
  store.commit("openConection");
  return Promise.reject(error);
}

/**
 * Função interceptor para alterar a resposta da request
 * @param config
 * @returns {*}
 */
export function response_ok(response) {
  store.commit("closeConection");
  return response;
}

/**
 * Função interceptor para manipular algum erro na resposta da request.
 * Se status da resposta for 401 dispara um refresh token e tenta a request novamente
 * @param error
 * @returns {Promise<never>|Promise<unknown>}
 */
export function response_error(error) {
  client = client_rest;

  store.commit("closeConection");

  const original_request = error.config;

  if (error.response.status === 401) {
    //token expirado, tenta atualizar ele

    if (isRefreshing) {
      //se outra requisiçao já está atualizando o token, adiciona essa requisição à lista de falhas, para ser executada mais tarde
      return new Promise(function (resolve, reject) {
        failedQueue.push({ resolve, reject });
      })
        .then(() => {
          //atualiza o token na request original e tenta executá-la novamente
          original_request.headers["Authorization"] = store.getters.token;
          return client(original_request);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    }

    //A request retornou com erro 401, então seta a flag isRefreshing para true e dispara a requisição de atualização de token
    isRefreshing = true;
    requests.vue_login();
    return csrfToken.API.Objects.get_token().then((resp) => {
      let csrf_token = resp.data.csrf_token;
      return requests
      .post(`${process.env.VUE_APP_REFRESH_URL_PREFIX}refresh`, {
          _token: csrf_token,
          name: store.getters.user.name,
          refresh_token: store.getters.refresh_token     
      })
      .then((resp) => {
        if (resp.status == 200) {
          isRefreshing = false;
          //conseguiu atualizar o token
          if (store.getters.user) {
            //salva o novo token
            store.dispatch("login", resp.data);

            //dispara o processo que executará as requests que estavam com falha
            processQueue(null, store.getters.token);

            //atualiza o token na request original e tenta executá-la novamente
            original_request.headers["Authorization"] = store.getters.token;
            return client(original_request);
          }
        }
      })
      .catch(() => {
        //falha na atualização do token - sessão expirada no backend
        isRefreshing = false;

        //limpa a fila de requests com falha
        failedQueue = [];

        store.commit("set_message", {
          message: "A sessão expirou!",
          color: "error",
          type: "error",
        });

        store.dispatch("logoff");

      });
    }).catch((err) => {
      return Promise.reject(err);
    });    
  } else {
    return Promise.reject(error);
  }
}
